import React from 'react';
import { Link } from 'gatsby';

import './style.css';

/**
 * Компонент карточки мастер-класса на главной.
 * @class
 * @param {Object} props            данные, пришедшие от родителя
 * @param {Object} props.slug       ссылка на запись для запроса на сервер
 * @param {Object} props.id         номер записи для значения key
 * @param {Object} props.title      имя записи
 * @param {Object} props.content    содержание записи
 * @param {Object} props.category   категория записи
 * @extends react-router-dom 
 * @memberof Home
 */
const Article = (props) => {
    let main_image;
    let price = '0 руб.', price_arr_new;
    if (props.content !== undefined) {
        let image_arr_old = props.content.split('main-image">');
        if (image_arr_old.length > 1) {
            image_arr_old.shift();
            if (image_arr_old.length !== 0 && image_arr_old !== undefined) {
                let image_arr_new = image_arr_old[0].split('</figure>');
                main_image = image_arr_new[0];
                let price_arr_old = props.content.split('price">');
                if (price_arr_old.length > 1 ) {
                    price_arr_old.shift();
                    price_arr_new = price_arr_old[0].split('</p>');
                    price = price_arr_new[0];
                } else {
                    price = '0 руб.';
                }
            }
        }
    }
    
    return (
        <li className="master-class__item" key={props.id} data-category={props.category}>
            <div className="master-class__item_container">
                <Link to={'/mc/' + props.slug} className="article">
                    <div className="article-image" dangerouslySetInnerHTML={{ __html: main_image === undefined ? null : main_image}}></div>
                    <div className="article-description">
                        <h4 className="article-description__title">{props.title}</h4>
                        <p className="article-description__price">{price}</p>
                    </div>
                </Link>
            </div>
        </li>
    )
}

export default Article;
